import { useGetAllDealerAddressBrandPaymentQuery, useCreateDealerAddressBrandPaymentMutation, useUpdateDealerAddressBrandPaymentMutation, useGetDealerPaymentCurrencyQuery } from '../../../../../api';
import { useLanguage } from '../../../../../contexts/LanguageContext';
import React, { useState } from 'react';

const MODELS_PREVIEW_COUNT = 3;

export const usePaymentData = ({ dealerAddressBrandId, dealerAddress, brand, pageSize = 10, enabled = true }) => {
    const { th } = useLanguage();

    const [pageNumber, setPageNumber] = useState(1);

    const {
        data = { items: [], count: 0 },
        isLoading,
        isFetching,
        isError,
        error,
        refetch
    } = useGetAllDealerAddressBrandPaymentQuery(
        {
            dealerAddressBrandId,
            pageNumber,
            pageSize
        },
        { skip: !enabled }
    );

    const { data: currencyData } = useGetDealerPaymentCurrencyQuery({ dealerAddressBrandId }, { skip: !enabled || !dealerAddressBrandId });

    const [createPayment] = useCreateDealerAddressBrandPaymentMutation();
    const [updatePayment] = useUpdateDealerAddressBrandPaymentMutation();

    const modelsBody = (rowData) => {
        const names = (rowData.models || []).map((m) => m.name).filter(Boolean);
        if (!names.length) return <span className="text-500">{th('customerAddressBrand.tabs.payment.models.empty')}</span>;

        const moreCount = names.length - MODELS_PREVIEW_COUNT;
        const tooltip = `${th('customerAddressBrand.tabs.payment.models.tooltipTitle')}\n${names.join('\n')}`;

        return (
            <span title={tooltip}>
                {names.slice(0, MODELS_PREVIEW_COUNT).join(', ')}
                {moreCount > 0 && <span className="ml-1 text-500">{th('customerAddressBrand.tabs.payment.models.moreCount', { count: moreCount })}</span>}
            </span>
        );
    };

    const columns = [
        { field: 'models', header: th('customerAddressBrand.tabs.payment.columns.models'), body: modelsBody, sortable: false, style: { minWidth: '180px', maxWidth: '260px' } },
        { field: 'warrHourlyRate', header: th('customerAddressBrand.tabs.payment.columns.warrHourlyRate') },
        { field: 'normalHourlyRate', header: th('customerAddressBrand.tabs.payment.columns.normalHourlyRate') },
        { field: 'currencyUnits', header: th('customerAddressBrand.tabs.payment.columns.currencyUnits') },
        { field: 'contractStartDate', header: th('customerAddressBrand.tabs.payment.columns.contractStartDate'), bodyField: 'contractStartDate' },
        { field: 'contractEndDate', header: th('customerAddressBrand.tabs.payment.columns.contractEndDate'), bodyField: 'contractEndDate' }
    ];

    const save = async (formData) => {
        try {
            if (formData.id) {
                const payload = {
                    id: formData.id,
                    dealerAddressBrandId,
                    modelIds: formData.modelIds || [],
                    warrHourlyRate: Number(formData.warrHourlyRate) || 0,
                    normalHourlyRate: Number(formData.normalHourlyRate) || 0,
                    currencyUnits: formData.currencyUnits || '',
                    contractStartDate: formData.contractStartDate ? new Date(formData.contractStartDate).toISOString() : null,
                    contractEndDate: formData.contractEndDate ? new Date(formData.contractEndDate).toISOString() : null
                };
                await updatePayment(payload).unwrap();
            } else {
                const payload = {
                    dealerAddressBrandId,
                    siteUseId: dealerAddress.id,
                    modelIds: formData.modelIds || [],
                    warrHourlyRate: Number(formData.warrHourlyRate) || 0,
                    normalHourlyRate: Number(formData.normalHourlyRate) || 0,
                    currencyUnits: formData.currencyUnits || '',
                    contractStartDate: formData.contractStartDate ? new Date(formData.contractStartDate).toISOString() : null,
                    contractEndDate: formData.contractEndDate ? new Date(formData.contractEndDate).toISOString() : null
                };
                await createPayment(payload).unwrap();
            }
            refetch();
        } catch (err) {
            console.error('❌ Payment kayıt hatası:', err);
        }
    };

    return {
        payments: data.items,
        count: data.count,
        isLoading: isLoading || isFetching,
        columns,
        save,
        refetch,
        pageNumber,
        setPageNumber,
        pageSize,
        brand,
        dealerCurrency: currencyData?.currency || null
    };
};
